import appContent from '@/services/content/appContent.typed';
import {twx} from '@/utils/tailwindUtils';

const AutoDeliveryDcxNextDeliveryTitle = ({
    nextDeliveryDate,
    className,
}: {
    nextDeliveryDate?: string | null;
    className?: string;
}) => {
    if (nextDeliveryDate === null) return null;

    const {nextDeliveryTitle} = appContent.getAutoDeliveryContent()?.dashboardContent || {};

    if (!nextDeliveryTitle) return null;

    return (
        <div className={twx('text-14 leading-[20px] tracking-04 text-primary-dark', className)}>
            {nextDeliveryTitle}
        </div>
    );
};

export default AutoDeliveryDcxNextDeliveryTitle;
